/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsLocaleGroup,
    MelcoModelsLocaleGroupFromJSON,
    MelcoModelsLocaleGroupFromJSONTyped,
    MelcoModelsLocaleGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsLocaleGroup
 */
export interface MelcoModelsGenericList1MelcoModelsLocaleGroup {
    /**
     * 
     * @type {Array<MelcoModelsLocaleGroup>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    list: Array<MelcoModelsLocaleGroup>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsLocaleGroupFromJSON(json: any): MelcoModelsGenericList1MelcoModelsLocaleGroup {
    return MelcoModelsGenericList1MelcoModelsLocaleGroupFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsLocaleGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsLocaleGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsLocaleGroupFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsLocaleGroupToJSON(value?: MelcoModelsGenericList1MelcoModelsLocaleGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsLocaleGroupToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


